import Model from "../Model";

class Representantzonetops extends Model{

    buildUrl ({ param }) {
        return ['/employeeview/topzoneid', param];
    }

    all(config = {}) {
        return this.request({ method: 'POST', action: 'all', ...config });
    }
}


export default new Representantzonetops;